export const initLazyImages = () => {
	const componentsWithLazyImages = document.querySelectorAll( '.with-lazy-images' );

	if ( !componentsWithLazyImages.length )
	{
		return;
	}

	Array.from( componentsWithLazyImages ).forEach( ( it ) => {
		const handleScroll = () => {
			if ( it.getBoundingClientRect().y < window.innerHeight && it.getBoundingClientRect().y + it.getBoundingClientRect().height > window.innerHeight * -1 )
			{
				const lazyImages = it.querySelectorAll( '[data-lazy-src], [data-lazy-srcset]' );

				if ( !lazyImages.length )
				{
					it.classList.remove( 'with-lazy-images' );
					window.removeEventListener( 'scroll', handleScroll );
					
					return;
				}

				Array.from( lazyImages ).forEach( ( it ) => {
					if ( it.dataset.lazySrc )
					{
						it.src = it.dataset.lazySrc;
					}
					
					if ( it.dataset.lazySrcset )
					{
						it.srcset = it.dataset.lazySrcset;
					}

					it.removeAttribute( 'data-lazy-src' );
					it.removeAttribute( 'data-lazy-srcset' );
				} );

				it.classList.remove( 'with-lazy-images' );
				window.removeEventListener( 'scroll', handleScroll );
			}
		};

		window.addEventListener( 'scroll', handleScroll );
		handleScroll();
	} );
};